// extracted by mini-css-extract-plugin
export default {"profileImage":"institutionAvatar_profileImage__LBWhe","editButton":"institutionAvatar_editButton__1f+mR"};